import {
	BoundActions,
	createActionsHook,
	createHook,
	createStateHook,
	HookActionsFunction,
	HookFunction,
	HookStateFunction,
	StoreActionApi,
} from 'react-sweet-state';

import { orgContextStore } from './store-internal';
import { OrgContext } from './types';

export const useOrgContextStore: HookFunction<
	OrgContext,
	BoundActions<
		OrgContext,
		{
			setOrgContext: (orgContext: OrgContext) => ({ setState }: StoreActionApi<OrgContext>) => void;
		}
	>,
	void
> = createHook(orgContextStore);
export const useOrgContextActions: HookActionsFunction<
	BoundActions<
		OrgContext,
		{
			setOrgContext: (orgContext: OrgContext) => ({ setState }: StoreActionApi<OrgContext>) => void;
		}
	>
> = createActionsHook(orgContextStore);

// State hooks
export const useNoOrgExperience: HookStateFunction<boolean, void> = createStateHook(orgContextStore, {
	selector: state => !state.orgId,
});
export const useOrgContextOrgId: HookStateFunction<string, void> = createStateHook(orgContextStore, {
	selector: state => state.orgId,
});
export const useOrgContextCloudIds: HookStateFunction<string[], void> = createStateHook(orgContextStore, {
	selector: state => state.cloudIds,
});
export const useOrgContextIsOrgAdmin: HookStateFunction<boolean | undefined, void> = createStateHook(orgContextStore, {
	selector: state => state.isOrgAdmin,
});
